<template>
  <div class="box" style="height:100%;">
    <div class="notice">
      <!-- <h1 class="title">
        <div class="titlemsg">
          <span v-if="tabName=='gg'" @click="clickNotice(1)">  公告阅读</span>
          <span v-if="tabName=='jj'" @click="clickNotice(2)">  商品简介</span>
        </div>
      </h1> -->
      <div v-if="isNotice" class="topone">
        <div class="notContent">
          <p class="item" v-for="(noticeItem,index) in noticeList" :key="index" style="display:flex;flex-direction:column;cursor: pointer;" @click="goDetail(noticeItem.id)">
            <span class="time">{{ noticeItem.time }}</span>
            <span class="word">[公告]{{ noticeItem.title }}</span>
          </p>
        </div>
        <div class="pageWrap">
          <!-- :pager-count="6" -->
          <el-pagination
            popper-class="_popStyle"
            :current-page="pageData.currentPage"
            :page-sizes="pageData.pageSizes"
            :page-size="pageData.pageSize"
            layout="prev, pager, next"
            :total="pageData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
        <!-- <div class="more">
          查看更多
        </div> -->
      </div>
      <div v-else class="commodityMsg">
        <el-row>
          <el-col :span="6" :offset="1">交易品种</el-col>
          <el-col :span="16" class="fr" >{{ selectCommodityStrategy.commodityName }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">品种代码</el-col>
          <el-col :span="11" class="fr">{{ selectCommodityStrategy.commodityCode }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">报价单位</el-col>
          <el-col :span="11" class="fr">{{ selectCommodityStrategy.unitQuantifier }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">商品状态</el-col>
          <el-col :span="11" class="fr"> 在市 </el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">价格最小变动单位</el-col>
          <el-col :span="11" class="fr">{{ selectCommodityStrategy.minPriceChange }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">最大买进数量</el-col>
          <el-col :span="11" class="fr">{{ selectCommodityStrategy.maxHoldAmount }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">到期时间</el-col>
          <el-col :span="11" class="fr">{{ selectCommodityStrategy.downMarketTime|dateFormateDay }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <!-- <el-row>
          <el-col :span="11" :offset="1">交收起始日</el-col>
          <el-col :span="11">{{ selectCommodityStrategy.pickupStartTime }}</el-col>
        </el-row>-->
        <el-row>
          <el-col :span="6" :offset="1">交收品种</el-col>
          <el-col :span="16" class="fr">{{ selectCommodityStrategy.commodityName }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <el-row>
          <el-col :span="11" :offset="1">单笔下单数量范围</el-col>
          <el-col :span="11" class="fr">{{ selectCommodityStrategy.minSingleTradeAmount }}~{{ selectCommodityStrategy.maxSingleTradeAmount }}</el-col>
        </el-row>
        <div class="hx-lines"></div>
        <!-- <div class="colum-lines"></div> -->
      </div>
    </div>
    <descDialog ref="descDialog" />
  </div>
</template>
<script>
/*global http protocol util */
import { mapGetters } from 'vuex'
import descDialog from '../../notice/tab/detailDialog.vue'
export default {
  name: 'NoticeCC',
  components: {
    descDialog
  },
  props: {
    tabName: {
      type: String,
      default: 'gg'
    }
  },
  data() {
    return {
      pageData: {
        total: null,
        pageSizes: [10, 20, 30, 40],
        pageSize: 7,
        currentPage: 1
      },
      items: [],
      oneItmes: {},
      content: '',
      isNotice: true,
      abstract: [],
      klineTimeout: null,
      noticeList: [],
      CommodityTqTip: [],
      ConcludeStage: []
    }
  },
  computed: {
    // 商品策略
    ...mapGetters(['commodityStrategyGetter']),
    item() {
      const item = this.$store.state.hqData.item.symbolId
      if (item) {
        return this.$store.state.hqData.item.symbolId
      } else {
        if (this.$store.state.hqData.marketDetails.length > 0) {
          return this.$store.state.hqData.marketDetails[0].symbolId
        } else {
          return '--'
        }
      }
    },
    selectCommodityStrategy() {
      if (this.item !== '--' && this.commodityStrategyGetter.length > 0) {
        for (const CommodityStrategy of this.commodityStrategyGetter) {
          if (this.item == CommodityStrategy.commodityId) {
            return CommodityStrategy
          }
        }
      } else if (this.item == '--' && this.commodityStrategyGetter.length > 0) {
        return this.commodityStrategyGetter[0]
      }
      return {
        canBuy: '--',
        canDqDelivery: '--',
        canSell: '--',
        canShow: '--',
        canTqDelivery: '--',
        canTqTransfer: '--',
        canTransfer: '--',
        commodityCode: '--',
        commodityId: null,
        commodityName: '--',
        feeStrategyId: '--',
        guidePrice: '--',
        holdStrategyId: '--',
        margin: '--',
        marginStrategyId: '--',
        marginType: '--',
        marketPrice: '--',
        maxHoldAmount: '--',
        maxSingleTradeAmount: '--',
        maxUpDownWidth: '--',
        minAmountChange: '--',
        minPickupAmount: '--',
        minPriceChange: '--',
        minSingleTradeAmount: '--',
        offerEndTime: 0,
        openFee: '--',
        openFeeType: '--',
        pickupCountdown: '--',
        pickupStandard: '--',
        pickupStartTime: 0,
        tradeStrategyId: '--',
        transferFee: '--',
        transferFeeType: '--',
        unitNumeral: '--',
        unitQuantifier: '--',
        sellMargin: '--',
        sellMarginType: '--'
      }
    }
  },
  watch: {
    unit() {
      this.content = ''
      this.getOneActicle()
    },
    tabName(val) {
      if (val == 'gg') {
        this.getArticle()
        this.clickNotice(1)
      } else {
        this.clickNotice(2)
      }
    }
  },
  mounted() {
    this.init()
  },
  beforeDestroy() {
    protocol.param_noticeList.param.articleTitle = ''
    clearTimeout(this.klineTimeout)
  },
  methods: {
    goDetail(id) {
      this.$refs.descDialog.showDialog(id)
    },
    init() {
      if (this.tabName == 'gg') {
        this.getArticle()
        this.clickNotice(1)
      } else {
        this.clickNotice(2)
      }
    },
    clickNotice(id) {
      if (id == 1) {
        this.isNotice = true
      } else {
        this.getArticle()
        this.isNotice = false
      }
    },
    getArticle() {
      this.noticeList = []
      protocol.param_noticeList.param.page = this.pageData.currentPage - 1
      protocol.param_noticeList.param.size = this.pageData.pageSize
      http.getRes(protocol.param_noticeList).then((response) => {
        const { content, totalElements } = response.data.value
        this.pageData.total = Number(totalElements)
        if (content) {
          for (const value of content) {
            const obj = value
            obj.time = util.dateDayFormate(
              Number(value.createTime)
            )
            this.noticeList.push(obj)
          }
        }
      })
    },
    handleSizeChange(val) {
      this.pageData.pageSize = val
      this.getArticle()
    },
    handleCurrentChange(val) {
      this.pageData.currentPage = val
      this.getArticle()
    },
    goNotice() {
      window.sessionStorage.setItem('selectnPage', 2)
      this.$router.push('/notice'
      )
    },
    goWhitePage() {
      window.sessionStorage.setItem('selectnPage', 1)
      this.$router.push('/notice'
      )
    }
  }
}
</script>
<style scoped lang="scss">
.box {
  width: 100%;
  // background: #161719;
  padding-top: 0;
  overflow: hidden;
  .notice {
    height: 100%;
    .title {
      height: 35px;
      font-size: 14px;
      line-height: 35px;
      // background: #161719;
      text-indent:20px;
      font-weight: normal;
      border-bottom: 1px solid #1b1d24;
      .titlemsg{
        cursor:pointer;
        text-align:center;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .topone{
      // padding: 0 20px;
      height: 100%;
      overflow-y:auto;
      position: relative;
      a{
        display: flex;
        justify-content: space-between;
      }
      .item{
        padding: 14px 57px 9px 29px;
        border-bottom: 1px solid rgba($color: #ffffff, $alpha: 0.1);
      }
        .more{
          position: absolute;
          right:20px;
          bottom:20px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #0486FE;
        }
      .word{
 
        font-family: Source Han Sans SC;
        font-weight: 500;
        font-size: 14px;
        color: #DFDFDF;
        overflow: hidden;
        max-width: 75%;
        text-overflow:ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;

      }
      .time {

        font-size: 12px;
        font-weight: 600;
        color: rgba(255, 255, 255, 0.6);
  
      }
    }
    .top {
      height: 35px;
      padding: 0 20px;
      border-bottom: 1px solid rgba(78, 89, 133, 1);
      .word {
        width:50%;
        line-height: 35px;
        font-family: Source Han Sans SC;
        font-weight: 500;
        font-size: 14px;
        color: #DFDFDF;
        overflow: hidden;
        text-overflow:ellipsis;
        white-space: nowrap;
        -webkit-line-clamp: 1;
        color: #61688a;
        float: left;
      }
      .time {
        line-height: 35px;
        font-size: 12px;
        color: rgba(78, 89, 133, 1);
        float: right;
        width:50%;
      
      }
    }
  }
  .commodityMsg{
    position:relative;
    height: calc(100% - 35px);
    overflow: scroll;
    overflow-x: hidden;
    /deep/ .el-row{
   
      padding-left: 20px;
      line-height: 42px;
     height: 42px;
      font-size: 14px;
    }
    /deep/.el-col{
      font-family: Source Han Sans SC;
      font-weight: 400;
      font-size: 14px;
      color: #DFDFDF;
    }
    .fr{
      text-align:right;
    }
    div{
       color: #DFDFDF;
    }
    .hx-lines{
      width:100%;
      height: 1px;
      background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, rgba(61, 66, 102, 0.8) 54%, rgba(48, 53, 89, 0.4) 100%);
    }
    .colum-lines{
      position: absolute;
      top: 0;
      left: 50%;
      width: 1px;
      height: 278px;
      background: linear-gradient(45deg, rgba(94, 101, 146, 0.4) 0%, rgba(61, 66, 102, 0.8) 54%, rgba(48, 53, 89, 0.4) 100%);
    }
  }
  .notContent{
    height: 421px;
    overflow-y: auto;
    // padding: 0 20px;
  }
  .pageWrap{
    box-sizing: border-box;
    overflow: hidden;
    height: calc(100% - 421px);
    width: 100%;
    background-color:#141517;
    position: absolute;
    bottom: 5px;
    text-align: center;
    padding-top: 40px;
    border-top: 1px solid rgba($color: #ffffff, $alpha: 0.1);
    /deep/ .el-pagination {
      button:disabled, .btn-prev, .btn-next, .el-pager li {
        background-color: transparent;
      }
      button:disabled, button, button:disabled:hover {
        color: #979797;
      }
      button:hover {
        color: #ffffff;
      }
      .el-pager {
        li {
          font-family: Source Han Sans SC;
          font-weight: 400;
          font-size: 12px;
          color: #E8E8E8;
        }
        .active {
          font-weight: 800;
        }
      }
    }
  }
}
</style>
